import SvgIcon from '@material-ui/core/SvgIcon'

const UncheckedCheckBox = (props) => (
  <SvgIcon data-testid="UncheckedCheckBox" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="0.75" y="0.75" width="22.5" height="22.5" rx="3.25" />
  </SvgIcon>
)

export default UncheckedCheckBox
